import { IBlockPayment, JobTemplate } from "@project/shared-types";
import { useEffect, useMemo, useState } from "react";
import NotiSvg from "../../../assets/taiga-uikit/icons/info-circle.svg?react";
import AddTaskSvg from "../../../assets/taiga-uikit/icons/note-add.svg?react";
import { Button } from "../../../components/button/button";
import { FixedPage } from "../../../components/FixedPage/FixedPage";
import { InputDropdown } from "../../../components/inputs/InputDropdown";
import { Notification } from "../../../components/Notification/Notification";
import { OrderNewJob } from "../../../components/OrderTask/OrderNewJob";
import { Push } from "../../../components/Push/Push";
import { Text } from "../../../components/texts/text";
import Title from "../../../components/texts/title";
import { _size, _sizeHeading, _sizeText, _style } from "../../../core/core";
import "./JobsPayment.css";
interface IJobsPayment {
  block: IBlockPayment;
  count: number;
  setCount: React.Dispatch<React.SetStateAction<number>>;
  jobs: JobTemplate[];
  setJobs: React.Dispatch<React.SetStateAction<JobTemplate[]>>;
  setIsJobsActivePage: React.Dispatch<React.SetStateAction<boolean>>;
  IsJobsActivePage: boolean;
  onCreateOrder: () => void;
}
interface IOptionTime {
  key: string;
  label: string;
  text: string;
  interval: number;
}
export const JobsPayment = ({
  block,
  count,
  setCount,
  jobs,
  setJobs,
  IsJobsActivePage,
  setIsJobsActivePage,
  onCreateOrder,
}: IJobsPayment) => {
  const handleUpdateDataJob = (
    id: number,
    text: string,
    date: number,
    filename: string
  ) => {
    console.log("Update jobs handleUpdateDataJob");
    // Обновляем задание по id
    setJobs((prevJobs) =>
      prevJobs.map((job, index) =>
        index === id
          ? ({
            ...job,
            text: text,
            date_public: date,
            filename: filename,
          } as JobTemplate)
          : job
      )
    );
  };
  useEffect(() => {
    console.log("Update jobs");
    if (jobs.length > count) {
      setJobs(jobs.slice(0, count));
    } else if (jobs.length < count) {
      const newJobs = [];
      const interval = selectedTime.interval; // Интервал в днях
      const startDate = new Date(); // Начальная дата выполнения заданий
      for (let i = jobs.length; i < count; i++) {
        newJobs.push({
          date_public: getTimeStampInterval(startDate, i * interval), // Сохраняем дату в формате timestamp
          text: "",
        } as JobTemplate);
      }
      setJobs([...jobs, ...newJobs]);
    }
  }, [count]);
  const getOptionsTime = () => {
    return [
      {
        key: "0",
        label: "Раз в день",
        text: "Каждый день начнёт выполняться одно задание",
        interval: 1, // Интервал в днях
      },
      {
        key: "1",
        label: "Раз в неделю",
        text: "Каждые 7 дней начнёт выполняться одно задание",
        interval: 7, // Интервал в днях
      },
      {
        key: "2",
        label: "Раз в месяц",
        text: "Каждые 30 дней начнёт выполняться одно задание",
        interval: 30, // Интервал в днях
      },
    ] as IOptionTime[];
  };
  const getTimeStampInterval = (
    startDate: Date = new Date(),
    interval: number = 1
  ): number => {
    const jobDate = new Date(startDate);
    jobDate.setDate(startDate.getDate() + interval); // Расчёт даты выполнения
    return +jobDate;
  };
  const [selectedTime, setSelectedTime] = useState(getOptionsTime()[0]);

  useEffect(() => {
    console.log("Update selectedTime");
    if (jobs.length === 0) return;

    // Распределяем задания
    const startDate = new Date(); // Начальная дата выполнения заданий
    const interval = selectedTime.interval; // Интервал в днях

    const updatedJobs = jobs.map((job, index) => {
      return {
        ...job,
        date_public: getTimeStampInterval(startDate, index * interval), // Сохраняем дату в формате timestamp
      };
    });

    setJobs(updatedJobs);
  }, [selectedTime]);
  const readyRender = useMemo(() => {
    return jobs.map((job, index) => (
      <OrderNewJob
        key={`job_${index}`}
        id={index}
        job={job}
        onUpdateTask={handleUpdateDataJob}
      />
    ));
  }, [jobs]);
  const RenderItem = ({ index }: { index: number }) => {
    return readyRender[index];
  };
  return (
    <FixedPage
      id={123000}
      width="760px"
      className="jobs-payment"
      is_active={IsJobsActivePage}
      set_is_active={setIsJobsActivePage}
    >
      {IsJobsActivePage && (
        <>
          <Title type={_sizeHeading.h3}>Настройка заданий</Title>

          <div className="jobs-fileds-group">
            <InputDropdown
              onSelect={(option) =>
                setSelectedTime(
                  getOptionsTime().filter((opt) => opt.key === option.key)[0]
                )
              }
              labelOutside={"Выполнять задания"}
              selected={selectedTime}
              options={getOptionsTime()}
            >
              <Text size={_sizeText.m}>{selectedTime.label}</Text>
            </InputDropdown>
            <div className="field-notification-down">
              <Notification type={"success"} icon_left={<NotiSvg />}>
                <Text size={_sizeText.m}>{selectedTime.text}</Text>
              </Notification>
            </div>
          </div>
          <div className="jobs-list">
            <Push
              id={"123001"}
              status="success"
              title="Не обязательно заполнять всю информацию"
              text="Вы можете заполнять информацию по необходимости. Например, в одном указать фото, оставив без текста. В другом указать только дату."
            />
            <Push
              id={"123001"}
              status="success"
              title="Редактируйте в любой момент"
              text="Вы можете изменить информацию в любой момент, не обязательно сейчас"
            />
            {readyRender.map((job, index) => RenderItem({ index }))}
          </div>
          <Button
            onClick={() => {
              setCount(count + 1);
            }}
            width={"100%"}
            size={_size.M}
            style={_style.outline}
            icon_left={<AddTaskSvg />}
          >
            Добавить задание
          </Button>
          <Button onClick={onCreateOrder} width={"100%"} size={_size.M}>
            Оплатить заказ
          </Button>
        </>
      )}
    </FixedPage>
  );
};
